import { ImportFieldType } from "../../const/field-type";
import { SubscriptionSource } from "../../const/subscription-source";
import { ImportActionType } from "../../const/import-action-type";
import { SubscriptionStatus } from "../../const/import-subscription-status";
import { DuplicatesAction } from "../../const/duplicates-action";
import { TagsAction } from "../../const/tags-action";

function calculateOverrides(state, fields) {
  switch (state.actionType) {
    case ImportActionType.CustomMappings: {
      return fields.map(() => "1").join(",");
    }
    case ImportActionType.AddUpdateTags: {
      if (TagsAction.Overwrite) {
        return fields.map((field) => (field === ImportFieldType.TAGS ? "1" : "0")).join(",");
      }
      return fields.map(() => "0").join(",");
    }
    case ImportActionType.UpdateEmailSubscribersStatus: {
      if (state.subscriptions.source === SubscriptionSource.File) {
        return fields.map((field) => (field === ImportFieldType.EMAIL_SUBSCRIPTION_STATUS ? "1" : "0")).join(",");
      } else {
        return fields.map(() => "1").join(",");
      }
    }
    case ImportActionType.UpdateSMSSubscribersStatus: {
      if (state.subscriptions.source === SubscriptionSource.File) {
        return fields.map((field) => (field === ImportFieldType.SMS_SUBSCRIPTION_STATUS ? "1" : "0")).join(",");
      } else {
        return fields.map(() => "1").join(",");
      }
    }
    case ImportActionType.AddNewUsers: {
      return fields.map(() => (state.duplicates === DuplicatesAction.Override ? "1" : "0")).join(",");
    }
  }
}

function overwriteEmailSubscription(state, overwrites) {
  const index = state.fieldMappings.selectedFields.findIndex((f) => f === ImportFieldType.EMAIL_SUBSCRIPTION_STATUS);
  const hasMapping = index > -1 && overwrites[index] === "1";
  const isManualSubscription = state.subscriptions.source === SubscriptionSource.Manual;
  return hasMapping || isManualSubscription ? 1 : 0;
}

function overwriteSmsSubscription(state, overwrites) {
  const index = state.fieldMappings.selectedFields.findIndex((f) => f === ImportFieldType.SMS_SUBSCRIPTION_STATUS);
  const hasMapping = index > -1 && overwrites[index] === "1";
  const isManualSubscription = state.subscriptions.source === SubscriptionSource.Manual;
  return hasMapping || isManualSubscription ? 1 : 0;
}

function overwriteWhatsappSubscription(state, overwrites) {
  const index = state.fieldMappings.selectedFields.findIndex((f) => f === ImportFieldType.WHATSAPP_SUBSCRIPTION_STATUS);
  const hasMapping = index > -1 && overwrites[index] === "1";
  const isManualSubscription = state.subscriptions.source === SubscriptionSource.Manual;
  return hasMapping || isManualSubscription ? 1 : 0;
}

function calculateInverts(fields) {
  return fields.map(() => "0").join(",");
}

function prepareTags(state) {
  return state.tags.importTags
    .filter((tag) => tag.isSelected)
    .map((tag) => tag.name)
    .join(",");
}

// isUnsubscribed
function mapEmailSubscription(status) {
  switch (status) {
    case SubscriptionStatus.Subscribed:
      return "0";
    case SubscriptionStatus.Unsubscribed:
      return "1";
    case SubscriptionStatus.Unknown:
      return "2";
    default:
      return null;
  }
}

// smsSubscriptionStatus
function mapSmsSubscription(status) {
  switch (status) {
    case SubscriptionStatus.Unsubscribed:
      return "0";
    case SubscriptionStatus.Subscribed:
      return "1";
    case SubscriptionStatus.Unknown:
      return "2";
    default:
      return null;
  }
}

// whatsappSubscriptionStatus
function mapWhatsappSubscription(status) {
  switch (status) {
    case SubscriptionStatus.Unsubscribed:
      return "0";
    case SubscriptionStatus.Subscribed:
      return "1";
    case SubscriptionStatus.Unknown:
      return "2";
    default:
      return null;
  }
}

export function mapStateToImportConfig(state) {
  const fields = state.fieldMappings.selectedFields;
  const overwrites = calculateOverrides(state, fields);
  return {
    mapping: fields.join(","),
    overwrites,
    inverted: calculateInverts(fields),
    resurrectDeletedCustomers: state.resurrectCustomer ? 1 : 0,
    updateTags: 0,
    skipFirstLine: +state.skipFirstLine,
    dataImportId: state.importId,
    overwriteSubscriptionStatus: overwriteEmailSubscription(state, overwrites.split(",")),
    overwriteSmsSubscriptionStatus: overwriteSmsSubscription(state, overwrites.split(",")),
    overwriteWhatsappSubscriptionStatus: overwriteWhatsappSubscription(state, overwrites.split(",")),
    isUnsubscribed: mapEmailSubscription(state.subscriptions.email),
    smsSubscriptionStatus: mapSmsSubscription(state.subscriptions.sms),
    whatsappSubscriptionStatus: mapWhatsappSubscription(state.subscriptions.whatsapp),
    treatNegativeStatusAsUnknown: state.treatNegativeStatusAsUnknown,
    tags: prepareTags(state),
    actionType: prepareActionType(state),
    setStatuses: prepareSetStatuses(state),
    duplicates: prepareDuplicates(state),
    actionForTags: prepareActionForTag(state),
  };
}

function prepareActionType(state) {
  switch (state.actionType) {
    case ImportActionType.AddNewUsers:
      return "Add or update customers";
    case ImportActionType.AddUpdateTags:
      return "Add or update tags";
    case ImportActionType.UpdateSMSSubscribersStatus:
      return "Update sms subscribers";
    case ImportActionType.UpdateEmailSubscribersStatus:
      return "Update email subscribers";
    case ImportActionType.CustomMappings:
      return "Custom";
    case ImportActionType.None:
      return "None";
  }
}

function prepareDuplicates(state) {
  switch (state.duplicates) {
    case DuplicatesAction.Override:
      return "Overwrite";
    case DuplicatesAction.Ignore:
      return "Ignore";
  }
}

function prepareSetStatuses(state) {
  switch (state.subscriptions.source) {
    case SubscriptionSource.File:
      return "From File";
    case SubscriptionSource.Manual:
      return "Manual";
    case SubscriptionSource.NoUpdate:
      return "No update";
  }
}

function prepareActionForTag(state) {
  switch (state.tags.action) {
    case TagsAction.Add:
      return "Add";
    case TagsAction.Overwrite:
      return "Overwrite";
    default:
      return "NONE";
  }
}
